import { Phrases } from '@shared/models/locales.model';

export default {
  PreCreateDialog: {
    Title: 'اختر عميلك',
    Desc: 'يرجى اختيار أحد عملائك لبدء إنشاء الشحنة ل',
    MyCustomer: 'عميلي',
    Template: 'القالب',
    Continue: 'استمر',
  },
} as Phrases;
